<template>
	<el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
			<el-row>
				<el-col :span="12">
					<el-form-item label="编码" prop="code"><el-input v-model="dataForm.code" placeholder="新增完成后自动生成编码" readonly="true"></el-input></el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="收票人姓名" prop="pickName"><el-input v-model="dataForm.pickName" placeholder="收票人姓名"></el-input></el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="收票人电话" prop="phone"><el-input v-model="dataForm.phone" placeholder="收票人电话"></el-input></el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="收票人地址" prop="pickAddress"><el-input v-model="dataForm.pickAddress" placeholder="收票人地址"></el-input></el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item prop="isDefault">
					    <el-checkbox v-model="dataForm.isDefault" true-label="1" false-label="0">设为默认</el-checkbox>
						<el-checkbox v-model="dataForm.isEnable" true-label="0" false-label="1">停用</el-checkbox>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<template slot="footer">
			<el-button @click="visible = false">{{ $t('cancel') }}</el-button>
			<el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
		</template>
	</el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        code: '',
        pickName: '',
        pickAddress: '',
        phone: '',
        isDefault: 0,
        isEnable: 0,
        isDefault: 0,
        isEnable: 0
      }
    }
  },
  computed: {
    dataRule () {
      return {
        pickName: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        pickAddress: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        phone: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        isDefault: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        isEnable: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http
        .get(`/sys/plat/ticket/pick/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data
          }
        })
        .catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs['dataForm'].validate(valid => {
          if (!valid) {
            return false
          }
          this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/ticket/pick/', this.dataForm)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            })
            .catch(() => {})
        })
      },
      1000,
      { leading: true, trailing: false }
    )
  }
}
</script>
